import * as _ from "lodash-es";
import React, { useContext, useEffect, useState } from "react";
import IGetOrderTimelineDTO from "../../../models/DTO/IGetOrderTimelineDTO";
import IOnGetOrderTimelineDTO from "../../../models/DTO/IOnGetOrderTimelineDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOrder from "../../../models/IOrder";
import IOrder_State_Log from "../../../models/IOrder_State_Log";
import IOrderUI from "../../../models/IOrderUI";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import UserService from "../../../services/UserService";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import "./OrderTimelineSidebar.scss";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";
import UIService from "../../../services/UIService";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import UserContext from "../../../contexts/UserContext";
import VendorContext from "../../../contexts/VendorContext";
import { SocketContext } from "../../../contexts/SocketContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UiContext from "../../../contexts/UiContext";
import OrderMessageService from "../../../services/OrderMessageService";
import { ResendCustomMessageModal } from "../ResendCustomMessageModal/ResendCustomMessageModal";

type Props = {
    close: () => void;
    orderModel: IOrder;
};

interface ITimelineDetailObject {
    [key: string]: IOrder_State_Log[];
}

export const OrderTimelineSidebar: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const [timeline, setTimeline] = useState<ITimelineDetailObject>({});

    const onGetOrderTimeline = (data: IOnGetOrderTimelineDTO) => {
        const timelineDetailObj: ITimelineDetailObject = {};

        for (const timelineDetail of data.orderStateLogs) {
            const dateStr = UserService.parseDate(timelineDetail.created_at);

            if (!timelineDetailObj[dateStr]) {
                timelineDetailObj[dateStr] = [timelineDetail];
            } else {
                timelineDetailObj[dateStr].push(timelineDetail);
            }
        }

        for (const key of Object.keys(timelineDetailObj)) {
            timelineDetailObj[key].sort((detailA, detailB) => {
                if (detailA.created_at < detailB.created_at) {
                    return -1;
                } else if (detailA.created_at > detailB.created_at) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }

        setTimeline(timelineDetailObj);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.OrderOnGetOrderTimeline, fn: onGetOrderTimeline }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getOrderTimeline();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const getOrderTimeline = () => {
        const payload: IGetOrderTimelineDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            orderGuid: props.orderModel.guid,
            supplierGuid: supplierModel.guid,
        };

        if (!userModel.isSupplierUser) {
            payload.vendorGuid = vendorModel.guid;
        }

        socket.emit(EndpointsEnum.OrderGetOrderTimeline, payload);
    };

    const closeModal = () => {
        uiContext.setModalComponent(null);
        uiContext.showModal(false);
    };

    const openResendModal = (timelineDetailItem: IOrder_State_Log) => {
        const handleResend = async (customMessage: string) => {
            try {
                await OrderMessageService.resendCustomMessage(
                    props.orderModel.guid,
                    { orderStateLogId: timelineDetailItem.id, customMessage },
                    userModel,
                    supplierModel,
                    !userModel.isSupplierUser ? vendorModel : undefined
                );
                closeModal();
                getOrderTimeline();
            } catch (e) {
                console.error(e);
            }
        };

        const modalComponent = (
            <ResendCustomMessageModal
                closeModalFn={closeModal}
                resendFn={handleResend}
                initialMessage={timelineDetailItem.custom_message || ""}
            />
        );

        uiContext.setModalComponent(modalComponent);
        uiContext.showModal(true);
    };

    let mainIndex = 0;

    return (
        <div className={"OrderTimelineSidebar p-3"}>
            <div className={"d-flex justify-content-between"}>
                <div className={""}>
                    <OwTitle title={"timeline"} tag={"h3"} />
                </div>
                <div className={"text-end"}>
                    <OwButton fn={props.close} centerIconClass={"fas fa-times"} className={"btn btn-danger"} />
                </div>
            </div>
            <div className={"mt-3 sidebar-scroll-content pb-5"}>
                <div className={"mb-4"}>
                    <div className={"date-title"}>{UserService.parseLastUpdated(props.orderModel.created_at, false, false)}</div>
                    <div className={"d-flex timeline-detail-item"}>
                        <div className={"w-10 side-section"}>
                            <i className={"circle"}>
                                <span>1</span>
                            </i>
                            <div className={"vertical-line"}></div>
                        </div>
                        <div className={"timeline-content w-90"}>
                            <div className={"w-100 d-flex justify-content-between"}>
                                <div className={"state"}>{_.startCase(_.lowerCase("Preliminary"))}</div>
                                <div className={"date"}>{UserService.parseLastUpdated(props.orderModel.created_at, true, false)}</div>
                            </div>
                            <div>
                                <OwLabel title={"by"} className={"me-2"} />
                                {props.orderModel.User?.name}
                            </div>
                        </div>
                    </div>
                </div>
                {Object.keys(timeline).map((timelineKey, index) => {
                    return (
                        <div key={`${timelineKey}-${index}`} className={"mb-4"}>
                            <div className={"date-title"}>{timelineKey}</div>
                            {timeline[timelineKey].map((timelineDetailItem) => {
                                mainIndex++;
                                mainIndex++;

                                return (
                                    <div key={timelineDetailItem.guid} className={"d-flex timeline-detail-item"}>
                                        <div className={"w-10 side-section"}>
                                            <i className={"circle"}>
                                                <span>{mainIndex}</span>
                                            </i>
                                            <div className={"vertical-line"}></div>
                                        </div>
                                        <div className={"timeline-content w-90"}>
                                            <div className={"w-100 d-flex justify-content-between"}>
                                                <div className={"state"}>
                                                    {_.startCase(_.lowerCase(timelineDetailItem.Order_State?.name))}
                                                </div>
                                                <div className={"date"}>
                                                    {UserService.parseLastUpdated(timelineDetailItem.created_at, true, false)}
                                                </div>
                                            </div>
                                            <div>
                                                <OwLabel title={"by"} className={"me-2"} />
                                                {timelineDetailItem.User?.name}
                                            </div>
                                            {timelineDetailItem.note?.length ? (
                                                <div className={"mt-4"}>
                                                    <OwLabel
                                                        leftIconClass={"fad fa-sticky-note"}
                                                        title={"note"}
                                                        isBold={true}
                                                        className={"me-2"}
                                                    />
                                                    <div>{timelineDetailItem.note}</div>
                                                </div>
                                            ) : null}
                                            {userModel.isSupplierUser && timelineDetailItem.internal_note?.length ? (
                                                <div className={"mt-4"}>
                                                    <OwLabel
                                                        leftIconClass={"fad fa-sticky-note"}
                                                        title={"internal_note"}
                                                        isBold={true}
                                                        className={"me-2"}
                                                    />
                                                    <div>{timelineDetailItem.internal_note}</div>
                                                </div>
                                            ) : null}
                                            {timelineDetailItem.custom_message?.length ? (
                                                <div className={"mt-4"}>
                                                    <OwLabel
                                                        leftIconClass={"fad fa-envelope"}
                                                        title={"outbound_message"}
                                                        isBold={true}
                                                        className={"me-2"}
                                                    />
                                                    <div>{timelineDetailItem.custom_message}</div>
                                                    {timelineDetailItem.message_last_sent_at ? (
                                                        <div className={"text-muted mt-1"}>
                                                            <small>
                                                                Last sent:{" "}
                                                                {UserService.parseLastUpdated(
                                                                    timelineDetailItem.message_last_sent_at,
                                                                    true,
                                                                    false
                                                                )}
                                                            </small>
                                                        </div>
                                                    ) : null}
                                                    {userModel.isSupplierUser ? (
                                                        <div className={"mt-2"}>
                                                            <OwButton
                                                                title={"edit_and_resend"}
                                                                leftIconClass={"fad fa-paper-plane"}
                                                                fn={() => openResendModal(timelineDetailItem)}
                                                            />
                                                        </div>
                                                    ) : null}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}

                <div className={"end-text"}>
                    <OwLabel className={"w-10"} title={"end"} />
                </div>
            </div>
        </div>
    );
};
